import { Heading, HeadingElement, HeadingProps, HeadingSize } from '@farol-ds/react'
import classNames from 'classnames'
import { useContext } from 'react'

import { PriceSize } from './constants'
import { PriceContext } from './context'
import styles from './price-value.module.scss'

export type PriceValueElement = HeadingElement

export type PriceValueProps = HeadingProps

const sizeMapping: Record<PriceSize, HeadingSize> = {
  md: '2xl',
  lg: '3xl',
}

function PriceValue(props: PriceValueProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  const ctx = useContext(PriceContext)
  const size = sizeMapping[ctx.size]
  return (
    <Heading {...rest} size={size} asChild>
      <span className={classes} {...rest}>
        {children}
      </span>
    </Heading>
  )
}

export default PriceValue
